<template>
  <section id="passengers" class="section pt-5">
    <div class="container">
      <div class="columns is-mobile detail is-vcentered">
        <div class="column is-6 has-text-left code pl-0">
          <h3 class="has-text-weight-bold is-size-1 has-text-caxton-blue">
            {{ detruta.idruta }}{{ detruta.manyana_tarde == 0 ? "M" : "T" }}
          </h3>
        </div>
        <div class="column is-4 is-offset-1 has-text-left code pl-0">
          <div class="field">
            <b-switch
              v-model="isSwitched"
              true-value="Solo ausentes"
              false-value="Todos"
              size="is-large"
            >
              {{ isSwitched }}
            </b-switch>
          </div>
        </div>
        <div class="column is-1 has-text-right code pr-0">
          <button class="button ios" type="button" @click="$emit('close')">
            <b-image
              :src="require('@/assets/images/ico-close-yellow.png')"
              alt="Next"
            ></b-image>
          </button>
        </div>
      </div>
      <div class="tablas section pl-0 pr-0 pt-0">
        <div class="columns is-mobile detail encabezado">
          <div class="column is-full has-text-left name pt-0 pl-0">
            <h4 class="has-text-weight-bold has-text-caxton-blue is-size-4">
              Lista Alumnos
            </h4>
          </div>
        </div>

        <div class="columns is-mobile is-multiline route detail passengers">
          <div
            :class="{
              column: true,
              'is-5': true,
              'is-offset-2': index % 2 == 1,
              last: trasladadosParada.length - index <= 2,
              'pl-0': true,
              'pr-0': true,
              passenger: true,
              ausente: tr.ausente == 4,
              aboard: tr.ausente == 2 || tr.ausente == 3
            }"
            v-for="(tr, index) in trasladadosParada.sort(function(a, b) {
              let anom = a.nombrecompleto.split(',')[0];
              let bnom = b.nombrecompleto.split(',')[0];

              if (anom > bnom) {
                return 1;
              }
              if (anom < bnom) {
                return -1;
              } else {
                return 0;
              }
            })"
            :key="tr.id"
          >
            <div class="columns is-mobile">
              <div class="column is-2 photo pl-0" @click="aboardToggle(tr)">
                <b-image
                  :src="imgurl + tr.expediente + '.jpg'"
                  :src-fallback="require('@/assets/images/no-photo-blue.png')"
                  alt="Next"
                  ratio="1by1"
                  rounded
                  @error="onErrorPic"
                ></b-image>
              </div>
              <div class="column is-8 is-of name" @click="aboardToggle(tr)">
                <p :style="safeguardingStyle(tr.safeguarding)">
                  <span class="lastname has-text-weight-bold">
                    {{ tr.nombrecompleto.split(",")[0] }},
                  </span>
                  <span class="firstname has-text-weight-bold">
                    {{ tr.nombrecompleto.split(",")[1] }}
                  </span>
                  <span class="age">
                    {{ tr.codigocurso }}-{{ tr.tutoria }}
                  </span>
                </p>
              </div>
              <div
                :class="{
                  column: true,
                  'is-2': true,
                  icons: true,
                  'has-text-right': true,
                  'pr-0': true,
                  'pl-0': true
                }"
                @click="pasarAusenteUltimaHora(tr)"
              >
                <b-image
                  :src="require('@/assets/images/ico-close-yellow-light.png')"
                  alt="Next"
                ></b-image>
              </div>
            </div>
          </div>
        </div>

        <div class="columns is-mobile detail encabezado">
          <div class="column is-full has-text-left name pt-0 pl-0">
            <h4 class="has-text-weight-bold has-text-caxton-blue is-size-4">
              Ausentes previstos
            </h4>
          </div>
        </div>
        <div class="columns is-mobile is-multiline route detail passengers">
          <div
            :class="{
              column: true,
              'is-5': true,
              'is-offset-2': index % 2 == 1,
              last: ausentesPrevistos.length - index <= 2,
              'pl-0': true,
              'pr-0': true,

              passenger: true,
              aboard: tr.ausente == 0
            }"
            v-for="(tr, index) in ausentesPrevistos"
            :key="tr.id"
          >
            <div class="columns is-mobile">
              <div class="column is-2 photo pl-0" @click="aboardToggle()">
                <b-image
                  :src="imgurl + tr.expediente + '.jpg'"
                  :src-fallback="require('@/assets/images/no-photo-blue.png')"
                  alt="Next"
                  ratio="1by1"
                  rounded
                  @error="onErrorPic"
                ></b-image>
              </div>
              <div class="column is-8 is-of name">
                <p :style="safeguardingStyle(tr.safeguarding)">
                  <span class="lastname has-text-weight-bold">
                    {{ tr.nombrecompleto.split(",")[0] }}
                  </span>
                  <span class="firstname has-text-weight-bold">
                    {{ tr.nombrecompleto.split(",")[1] }}
                  </span>
                  <span class="age">
                    {{ tr.codigocurso }}-{{ tr.tutoria }}
                  </span>
                </p>
                <p
                  style="color: #FFB612FF;font-size: 70%;border-left: 1px black dotted"
                  class="mt-1 ml-1 pl-2"
                  v-if="tr.motivocambio !== ''"
                >
                  {{ tr.motivocambio }}
                </p>
              </div>
              <div
                class="column is-2 icons has-text-right pr-0 pl-0"
                v-show="false"
              >
                <b-image
                  :src="require('@/assets/images/ico-close-yellow-light.png')"
                  alt="Next"
                ></b-image>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-mobile is-multiline route steps">
        <div class="column is-full has-text-right">
          <b-button
            size="is-medium"
            type="is-caxton-blue"
            rounded
            icon-left="arrow-right"
            @click="$router.push('/parada-cole-tarde/2')"
          >
          </b-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["tr", "imgpic", "detruta"],
  name: "Passengers",
  methods: {
    safeguardingStyle(safeguarding) {
      if (!safeguarding) return { color: "#0046ad" };
      const val = safeguarding.toLowerCase();
      if (val === "high") return { color: "#e00034" };
      if (val === "moderate") return { color: "#ffb612" };
      if (val === "low") return { color: "#00a651" };
      return { color: "#0046ad" };
    },
    onErrorPic(event, src) {
      console.log(src + " fails to load [" + event.type + "]");
    },
    aboardToggle(tr) {
      //Marca o desmarca si un alumno ha subido al autobús
      let alum = this.detruta.trasladados.filter(gr => gr.id == tr.id)[0];
      if (alum.ausente == 2) {
        alum.ausente = false;
      } else {
        alum.ausente = 2;
      }
      alum.fecha_control_ausencia = Date.now();
      console.log("Aboard toggle!");
    },
    pasarAusenteUltimaHora(tr) {
      let alum = this.detruta.trasladados.filter(gr => gr.id == tr.id)[0];
      if (alum.ausente == 4) {
        alum.ausente = 1;
      } else {
        alum.ausente = 4;
      }
      alum.fecha_control_ausencia = Date.now();

      console.log("Ausente Ultima Hora!");
    }
  },
  data() {
    return {
      isSwitched: "Todos",
      imgurl: process.env.VUE_APP_API_URL + process.env.VUE_APP_DIRPIC
    };
  },
  computed: {
    trasladadosParada() {
      if (this.detruta) {
        if (this.isSwitched == "Todos") {
          return this.detruta.trasladados.filter(tr => tr.ordenparada < 100);
        } else {
          return this.detruta.trasladados.filter(
            tr => tr.ordenparada < 100 && (tr.ausente == 4 || tr.ausente == 1)
          );
        }
      } else {
        return [];
      }
    },
    trasladadosCambioPuntual() {
      return this.detruta
        ? this.detruta.trasladados.filter(
            tr =>
              tr.cambiopuntual == 1 && tr.rutaoriginal != this.detruta.idruta
          )
        : [];
    },
    ausentesPrevistos() {
      return this.detruta
        ? this.detruta.trasladados.filter(tr => tr.ordenparada == 100)
        : [];
    }
  }
};
</script>

<style scoped></style>
